<div class="offline" *ngIf="parameters.offline">
    <p class="offline-title bg-error color-light text-align-center font-16">
        Offline</p>
</div>

<div class="offline"
     *ngIf="zones.zonesParameter.value > 0 && parameters.selectedModuleIsActive()"
     [class]="{ 'offline--second': parameters.offline }">
    <p class="offline-title bg-green color-light text-align-center font-16">
        {{ getControlModeName() }}
    </p>
</div>

<div class="zone__info no-active-zones"
     *ngIf="zones.noActiveZone
        && parameters.selectedModule.moduleStatus
        && parameters.selectedModule.controllerStatus
        && hasTiles()
        && !parameters.isZonesSystemControllerType()">
    <p class="zone__info-name bg-style color-light">
        {{ subtitle(2433) + '...' }}
    </p>
</div>

<div class="zones-wrapper"
     *ngIf="parameters.selectedModule.moduleStatus && parameters.selectedModule.controllerStatus"
     [ngStyle]="{ 'margin-top': (parameters.offline && zones.zonesParameter.value > 0)
        ? (70 + 'px')
        : (parameters.offline || zones.zonesParameter.value > 0) ? 35 + 'px' : 0}">
    <div *ngIf="zonesSystem.hasZonesData()">
        <zones-container *ngFor="let container of zonesSystem.containers"
                         [container]="container">

            <zones-container-tile *ngIf="zonesSystem.hasZonesSystemData()"
                                  [container]="container">
            </zones-container-tile>

            <ng-container *ngFor="let zone of (zonesSystem.hasZonesSystemData()
                ? container.data.zones : database.zones.getValue()['elements'])">
                <div class="zone bg-zone color-light color-grey-text box-shadow id{{zone.zone.id}}"
                     data-testid="zone"
                     *ngIf="views.zonesView.show && zone && zone.zone.visibility
                        && !(zone.zone.zoneState === 'zoneUnregistered' || zone.zone.zoneState === 'zoneOff')"
                     [ngClass]="{ 'border-light': !((zone.zone.zoneState === 'sensorDamaged'
                    || zone.zone.zoneState === 'noCommunication')
                    || zone.zone.duringChange)}">
                    <div class="zone__top border-zone cursor-pointer"
                         (click)="zones._selectZone(zone); zones.goToState('zone')">
                        <floating-subtitle class="zone__name font-21"
                                           [text]="zones.getZoneName(zone)">
                        </floating-subtitle>
                        <div class="zone__set-temperature bg-gradient bg-gradient--zone font-24 font-bold">
                            <p class="zone__set-temp" data-testid="set-temp"
                               *ngIf="(zone.mode.mode === 'localSchedule' || zone.mode.mode === 'globalSchedule')
                                    && !(zone.zone.zoneState === 'sensorDamaged' || zone.zone.zoneState === 'noCommunication')">
                                {{ zone.zone.setTemperature | format:7 }}
                            </p>
                            <p class="zone__set-temp" data-testid="set-temp"
                               *ngIf="(zone.mode.mode === 'constantTemp' || zone.mode.mode === 'timeLimit')
                                && !(zone.zone.zoneState === 'sensorDamaged' || zone.zone.zoneState === 'noCommunication')">
                                {{ zone.mode.setTemperature | format:7 }}
                            </p>
                            <icon [iconName]="'schedule'"
                                  data-testid="schedule-icon"
                                  [iconSize]="40"
                                  [className]="'zone__set-temperature-img fill-icon-grey-white'"
                                  *ngIf="(zone.mode.mode === 'localSchedule' || zone.mode.mode === 'globalSchedule')">
                            </icon>
                            <icon [iconName]="'constant-temp'"
                                  data-testid="constant-temp-icon"
                                  [iconSize]="40"
                                  [className]="'zone__set-temperature-img fill-icon-grey-white'"
                                  *ngIf="zone.mode.mode === 'constantTemp'
                                    && !(zone.zone.zoneState == 'sensorDamaged'
                                    || zone.zone.zoneState == 'noCommunication')">
                            </icon>
                            <div class="zone__time-limit-wrapper"
                                 *ngIf="!(zone.zone.zoneState == 'sensorDamaged' || zone.zone.zoneState == 'noCommunication')">
                                <icon [iconName]="'time-limit'"
                                      data-testid="time-limit-icon"
                                      [iconSize]="40"
                                      [className]="'zone__set-temperature-img fill-icon-grey-white'"
                                      *ngIf="zone.mode.mode == 'timeLimit'">
                                </icon>
                                <p class="zone__time-limit font-12" data-testid="zone-time-limit"
                                   *ngIf="zone.mode.mode === 'timeLimit'">
                                    {{ (zone.mode.constTempTime > 0 ? zone.mode.constTempTime : 1) | format:13 }}
                                </p>
                            </div>
                        </div>
                    </div>

                    <div class="zone__status cursor-pointer">
                        <div class="gradient-zone zone__status-background"
                             [ngClass]="{ 'zone__status--animated': zone.zone.flags.relayState == 'on' }"
                             data-testid="animation"
                             *ngIf="zone.zone.flags.algorithm == 'heating'">
                        </div>
                        <div class="gradient-zone-cooling zone__status-background"
                             [ngClass]="{ 'zone__status--animated': zone.zone.flags.relayState == 'on' }"
                             data-testid="animation"
                             *ngIf="zone.zone.flags.algorithm == 'cooling'">
                        </div>
                    </div>

                    <div class="zone__content cursor-pointer"
                         (click)="zones._selectZone(zone); zones.goToState('zone')">
                        <div class="zone__content-icon">
                            <zone-icon [name]="zone.description.styleIcon"
                                       [light]="!views.isMobileView()"
                                       [company]="parameters.urlCompany"
                                       class="zone__icon">
                            </zone-icon>
                        </div>
                        <div class="zone__current-temp" data-testid="tile-value"
                             *ngIf="!(zone.zone.zoneState == 'sensorDamaged' || zone.zone.zoneState == 'noCommunication')">
                            {{ zone.zone.currentTemperature | format:7 }}
                        </div>
                    </div>

                    <div class="zone__footer bg-style">
                        <div class="zone__icons">
                            <div class="zone__footer-icon zone__footer-icon--relay-status">
                                <div class="zone__img-wrapper border-light" data-testid="algorithm-icon">
                                    <img ngSrc="/assets/img/zone_icons/snowflake_white.svg"
                                         *ngIf="zone.zone.flags.algorithm === 'cooling'"
                                         width="25" height="25" alt=""/>
                                    <img ngSrc="/assets/img/zone_icons/sun_white.svg"
                                         *ngIf="zone.zone.flags.algorithm == 'heating'"
                                         width="25" height="25" alt=""/>
                                </div>
                            </div>
                            <div class="zone__footer-icon zone__footer-icon--actuators"
                                 [ngClass]="{ 'bg-cancel bg-cancel--roth': zone.actuatorAlert }"
                                 data-testid="actuators"
                                 *ngIf="zone.actuators.length > 0"
                                 title="{{ subtitle(2881) }}">
                                <div class="zone__img-wrapper border-light">
                                    <img ngSrc="/assets/img/zone_icons/actuator.svg"
                                         width="25" height="25" alt=""/>
                                    <p class="font-15">{{ zone.actuators.length }}</p>
                                </div>
                            </div>
                            <div class="zone__footer-icon zone__footer-icon--potential-free"
                                 [ngClass]="{ 'bg-cancel bg-cancel--roth': zone.windowSensorAlert }"
                                 data-testid="window-sensors"
                                 *ngIf="zone.windowsSensors.length > 0"
                                 title="{{ subtitle(3914) }}">
                                <div class="zone__img-wrapper border-light">
                                    <img ngSrc="/assets/img/zone_icons/window.svg"
                                         width="35" height="35" alt=""/>
                                    <p class="font-15">{{ zone.windowsSensors.length }}</p>
                                </div>
                            </div>

                            <div class="zone__footer-icon zone__footer-icon--potential-free"
                                 [ngClass]="{ 'bg-cancel bg-cancel--roth': zone.additionalContactAlert }"
                                 data-testid="relay"
                                 *ngIf="zone.additionalContacts.length > 0"
                                 title="{{ subtitle(3459) }}">
                                <div class="zone__img-wrapper border-light">
                                    <img ngSrc="/assets/img/zone_icons/relay.svg"
                                         width="35" height="35" alt=""/>
                                    <p class="font-15 margin-left-5">{{ zone.additionalContacts.length }}</p>
                                </div>
                            </div>
                        </div>
                        <div class="zone__icons">
                            <div class="zone__settings bg-input--primary cursor-pointer"
                                 (click)="zones.showHideDropdownList(zone.zone.id, 'underfloor')"
                                 [ngClass]="{ 'bg-cancel bg-cancel--roth': zone.underfloorAlert,
                                    'bg-input': !zone.underfloorAlert,
                                    'bg-input--open': !zone.underfloorAlert && zone.showDropdownUnderfloor,
                                    'bg-input--primary': !(!zone.underfloorAlert && zone.showDropdownUnderfloor) }"
                                 data-testid="underfloor"
                                 *ngIf="zone.underfloor.id"
                                 title="{{ subtitle(208) }}">
                                <icon [iconName]="'underfloor'"
                                      data-testid="underfloor-icon"
                                      [iconSize]="40"
                                      [className]="'fill-icon fill-icon--white'">
                                </icon>
                            </div>
                            <div class="zone__settings bg-input bg-input--primary cursor-pointer"
                                 (click)="zones.showHideDropdownList(zone.zone.id, 'info')"
                                 [ngClass]="{ 'bg-input--open': zone.showDropdownInfo,
                                    'bg-input--primary': !zone.showDropdownInfo }"
                                 title="{{ subtitle(2972) }}">
                                <icon [iconName]="'settings'"
                                      data-testid="settings-icon"
                                      [iconSize]="40"
                                      [className]="'fill-icon fill-icon--white'">
                                </icon>
                            </div>
                        </div>
                    </div>

                    <div class="dropdown-list dropdown-list--grey"
                         *ngIf="zone.showDropdownInfo"
                         (click)="zones.showHideDropdownList(0)"
                         [ngStyle]="{ 'bottom': zone.zoneStyle.bottom,
                            'top' : zone.zoneStyle.top}">
                        <div class="dropdown-list__item color-basic font-12 font-bold"
                             *ngIf="zone.zone.flags.algorithm === 'cooling'">
                            <p class="dropdown-list__item-name">
                                {{ subtitle(2459) }}
                            </p>
                            <div class="dropdown-list__value dropdown-list__value--single">
                                <p class="dropdown-list__value-name">
                                    {{ subtitle(1815) }}
                                </p>
                            </div>
                        </div>

                        @if (zone.mode.mode === 'timeLimit') {
                            <div class="dropdown-list__item color-basic font-12 font-bold">
                                <p class="dropdown-list__item-name">
                                    {{ subtitle(3516) }}
                                </p>
                            </div>
                        }

                        @if ((zone.mode.mode === 'localSchedule' || zone.mode.mode === 'globalSchedule')
                        && !views.zonesView.withoutGlobalSchedules) {
                            <div class="dropdown-list__item color-basic font-12 font-bold">
                                <p class="dropdown-list__item-name">
                                    {{ subtitle(293) }}
                                </p>
                                <div class="dropdown-list__value dropdown-list__value--single">
                                    <p class="dropdown-list__value-name">
                                        @if (zone.mode.mode === 'localSchedule') {
                                            {{ subtitle(3587) }}
                                        } @else {
                                            {{ zones.getScheduleName(zone.mode.scheduleIndex) }}
                                        }
                                    </p>
                                </div>
                            </div>
                        }
                        <div class="dropdown-list__item color-basic font-12 font-bold"
                             *ngIf="zone.zone.signalStrength !== null || zone.zone.batteryLevel !== null">
                            <p *ngIf="zone.zone.flags.floorSensor == null || zone.zone.flags.floorSensor == 0"
                               class="dropdown-list__item-name"
                               [ngClass]="{ 'color-alarm': zone.zone.batteryLevel <=10 && zone.zone.batteryLevel !== null }">
                                {{ subtitle(3589) }}
                            </p>
                            <p *ngIf="zone.zone.flags.floorSensor == 1 "
                               class="dropdown-list__item-name"
                               [ngClass]="{ 'color-alarm': zone.zone.batteryLevel <=10 && zone.zone.batteryLevel !== null }">
                                {{ subtitle(208) }}
                            </p>
                            <div class="dropdown-list__value">
                                <div class="dropdown-list__value-wrapper">
                                    <div class="dropdown-list__value dropdown-list__value--small"
                                         *ngIf="zone.zone.batteryLevel !== null">
                                        <img class="dropdown-list__battery"
                                             ngSrc="/assets/img/zone_icons/battery.svg"
                                             width="16" height="16" alt=""/>
                                        <p class="dropdown-list__value-name"
                                           data-testid="battery-level"
                                           [ngClass]="{ 'color-alarm': zone.zone.batteryLevel <= 10 && zone.zone.actuatorsOpen !== null }">
                                            {{ zone.zone.batteryLevel | format:8 }}
                                        </p>
                                    </div>
                                </div>
                                <div class="dropdown-list__value-wrapper">
                                    <div class="dropdown-list__value dropdown-list__value--small"
                                         *ngIf="zone.zone.signalStrength !== null">
                                        <img class="dropdown-list__signal"
                                             data-testid="signal-icon"
                                             ngSrc="{{ zones.signalIcon(zone.zone) }}"
                                             width="19" height="19" alt=""/>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="dropdown-list__item color-basic font-12 font-bold"
                             *ngIf="zone.zone.humidity > 0">
                            <p class="dropdown-list__item-name">
                                {{ subtitle(5465) }}
                            </p>
                            <div class="dropdown-list__value dropdown-list__value--actuator">
                                <img class="dropdown-list__actuators-open"
                                     ngSrc="/assets/img/zone_icons/humidity.svg"
                                     width="16" height="16" alt=""/>
                                <p class="dropdown-list__value-name">
                                    {{ zone.zone.humidity | format:8 }}
                                </p>
                            </div>
                        </div>

                        <div class="dropdown-list__item color-basic font-12 font-bold"
                             *ngIf="zone.actuators.length > 0">
                            <p class="dropdown-list__item-name">
                                {{ subtitle(1161) }}
                            </p>
                            <div class="dropdown-list__value dropdown-list__value--actuator">
                                <img class="dropdown-list__actuators-open"
                                     ngSrc="/assets/img/zone_icons/actuators__open.svg"
                                     width="16" height="16" alt=""/>
                                <p class="dropdown-list__value-name">
                                    {{ zone.zone.actuatorsOpen | format:8 }}
                                </p>
                            </div>
                        </div>

                        <div class="dropdown-list__item color-basic font-12 font-bold"
                             *ngIf="zone.zone.flags.humidityAlgorytm  > 0">
                            <p class="dropdown-list__item-name">
                                {{ subtitle(6372) }}
                            </p>
                            <div class="dropdown-list__value dropdown-list__value--single">
                                <p class="dropdown-list__value-name">
                                    {{ subtitle(3498) }}
                                </p>
                            </div>
                        </div>

                        <div class="dropdown-list__item color-basic font-12 font-bold"
                             *ngFor="let actuator of zone.actuators">
                            <p class="dropdown-list__item-name font-ellipsis"
                               [ngClass]="{ 'color-alarm': actuator.state !== 'noAlarm' && actuator.state !== 'waiting' }">
                                {{ subtitle(2729) + ' ' + (actuator.index) }}
                            </p>
                            <div *ngIf="actuator.state != 'noAlarm' && actuator.state != 'waiting' "
                                 class="dropdown-list__value dropdown-list__value--wide"
                                 [ngClass]="{ 'color-alarm': actuator.state != 'noAlarm' }">
                                <div>{{ subtitle(4282) }}</div>
                                <div class="dropdown-list__value--single">
                                    {{ zones.getStateSubtitle(actuator.state) }}
                                </div>
                            </div>

                            <div class="dropdown-list__value"
                                 *ngIf="actuator.state == 'noAlarm' && actuator.state != 'waiting'">
                                <div class="dropdown-list__value-wrapper">
                                    <div class="dropdown-list__value dropdown-list__value--small"
                                         *ngIf="actuator.batteryLevel !== null">
                                        <img class="dropdown-list__battery"
                                             ngSrc="/assets/img/zone_icons/battery.svg"
                                             width="16" height="16" alt=""/>
                                        <p data-testid="battery-level">
                                            {{
                                                actuator.signalStrength === '-1'
                                                || actuator.batteryLevel === '-1'
                                                    ? '--.- %;'
                                                    : actuator.batteryLevel + '%'
                                            }}
                                        </p>
                                    </div>
                                </div>
                                <div class="dropdown-list__value-wrapper">
                                    <div class="dropdown-list__value dropdown-list__value--small"
                                         *ngIf="actuator.signalStrength !== null">
                                        <img class="dropdown-list__signal"
                                             data-testid="signal-icon"
                                             ngSrc="{{ zones.signalIcon(actuator) }}"
                                             width="19" height="19" alt=""/>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div *ngFor="let sensor of zone.windowsSensors">
                            <div class="dropdown-list__item color-basic font-12 font-bold">
                                <p class="dropdown-list__item-name"
                                   [ngClass]="{ 'color-alarm': sensor.state !== 'noAlarm' && sensor.state !== 'waiting' }">
                                    {{ subtitle(3876) + ' ' + (sensor.index) }}
                                </p>
                                <p class="dropdown-list__item-name--error"
                                   *ngIf="sensor.state !== 'noAlarm' && sensor.state !== 'waiting'"
                                   [ngClass]="{ 'color-alarm alarm-left': sensor.state !== 'noAlarm' }">
                                    {{ subtitle(4282) }}
                                </p>

                                <div class="dropdown-list__value"
                                     *ngIf="sensor.state === 'noAlarm'">
                                    <div class="dropdown-list__value-wrapper">
                                        <div class="dropdown-list__value dropdown-list__value--small"
                                             *ngIf="sensor.batteryLevel !== null">
                                            <img class="dropdown-list__battery"
                                                 ngSrc="/assets/img/zone_icons/battery.svg"
                                                 width="16" height="16" alt=""/>
                                            <p class="dropdown-list__value-name"
                                               data-testid="battery-level"
                                               [ngClass]="{ 'color-alarm': sensor.state !== 'noAlarm' }">
                                                {{ sensor.batteryLevel | format:8 }}
                                            </p>
                                        </div>
                                    </div>
                                    <div class="dropdown-list__value-wrapper">
                                        <div class="dropdown-list__value dropdown-list__value--small"
                                             *ngIf="sensor.signalStrength !== null">
                                            <img class="dropdown-list__signal"
                                                 data-testid="signal-icon"
                                                 ngSrc="{{ zones.signalIcon(sensor) }}"
                                                 width="19" height="19" alt=""/>
                                        </div>
                                    </div>
                                </div>
                                <div class="dropdown-list__value dropdown-list__value--single"
                                     *ngIf="sensor.state === 'noCommunication'"
                                     [ngClass]="{ 'color-alarm': sensor.state !== 'noAlarm' }">
                                    <p class="dropdown-list__value-name">
                                        {{ subtitle(1808) }}
                                    </p>
                                </div>
                                <div class="dropdown-list__value dropdown-list__value--single"
                                     *ngIf="sensor.state === 'waiting'">
                                    <p class="dropdown-list__value-name">
                                        {{ subtitle(3162) }}
                                    </p>
                                </div>
                                <div class="dropdown-list__value dropdown-list__value--single"
                                     *ngIf="sensor.state === 'lowBattery'"
                                     [ngClass]="{ 'color-alarm': sensor.state !== 'noAlarm' }">
                                    <p class="dropdown-list__value-name">
                                        {{ subtitle(2885) }}
                                    </p>
                                </div>
                                <div class="dropdown-list__value dropdown-list__value--single"
                                     *ngIf="sensor.state === 'unregistered'"
                                     [ngClass]="{ 'color-alarm': sensor.state !== 'noAlarm' }">
                                    <p class="dropdown-list__value-name">
                                        {{ subtitle(3674) }}
                                    </p>
                                </div>
                            </div>
                            <div class="dropdown-list__item color-basic font-12 font-bold"
                                 *ngIf="sensor.state === 'noAlarm'">
                                <p class="dropdown-list__item-name">
                                    {{ subtitle(3956) }}
                                </p>
                                <div class="dropdown-list__value dropdown-list__value--single">
                                    <p class="dropdown-list__value-name"
                                       *ngIf="sensor.windowState === 'open'">
                                        {{ subtitle(3912) }}
                                    </p>
                                    <p class="dropdown-list__value-name"
                                       *ngIf="sensor.windowState === 'closed'">
                                        {{ subtitle(3913) }}
                                    </p>
                                </div>
                            </div>
                        </div>

                        <div class="dropdown-list__item color-basic font-12 font-bold"
                             *ngFor="let contact of zone.additionalContacts">
                            <p *ngIf="contact.textNumber === 0 || contact.textNumber === null"
                               class="dropdown-list__item-name"
                               [ngClass]="{ 'color-alarm': contact.state !== 'noAlarm' && contact.state !== 'waiting' }">
                                {{ subtitle(729) + ' ' + (contact.index) }}
                            </p>
                            <p *ngIf="contact.textNumber !== 0 && contact.textNumber !== null && contact.index == 1"
                               class="dropdown-list__item-name"
                               [ngClass]="{ 'color-alarm': contact.state !== 'noAlarm' && contact.state !== 'waiting' }">
                                {{ subtitle(contact.textNumber) }}
                            </p>
                            <p *ngIf="contact.textNumber !== 0 && contact.textNumber !== null && contact.index != 1"
                               class="dropdown-list__item-name"
                               [ngClass]="{ 'color-alarm': contact.state !== 'noAlarm' && contact.state !== 'waiting'}">
                                {{ subtitle(contact.textNumber) + ' ' + (contact.index) }}
                            </p>
                            <p class="dropdown-list__item-name--error"
                               *ngIf="contact.state !== 'noAlarm' && contact.state != 'waiting'"
                               [ngClass]="{ 'color-alarm alarm-left': contact.state !== 'noAlarm' }">
                                {{ subtitle(4282) }}
                            </p>

                            @if (contact.state === 'noAlarm') {
                                <div class="dropdown-list__value"
                                     [ngClass]="{ 'dropdown-list__value--single': !contact.signalStrength }">
                                    <div class="dropdown-list__value-wrapper">
                                        <div class="dropdown-list__value dropdown-list__value--small">
                                            <p class="dropdown-list__value-name"
                                               [ngClass]="{ 'color-alarm': contact.state !== 'noAlarm' }">
                                                {{ contact.relayState == 'on' ? subtitle(1447) : subtitle(924) }}
                                            </p>
                                        </div>
                                    </div>
                                    <div class="dropdown-list__value-wrapper">
                                        @if (contact.signalStrength !== null) {
                                            <div class="dropdown-list__value dropdown-list__value--small">
                                                <img class="dropdown-list__signal"
                                                     ngSrc="{{ zones.signalIcon(contact) }}"
                                                     width="16" height="16"
                                                     alt=""/>
                                            </div>
                                        }
                                    </div>
                                </div>
                            }

                            <div class="dropdown-list__value dropdown-list__value--single"
                                 *ngIf="contact.state === 'noCommunication'"
                                 [ngClass]="{ 'color-alarm': contact.state != 'noAlarm' }">
                                <p class="dropdown-list__value-name">
                                    {{ subtitle(1808) }}
                                </p>
                            </div>
                            <div class="dropdown-list__value dropdown-list__value--single"
                                 *ngIf="contact.state === 'waiting'">
                                <p class="dropdown-list__value-name">
                                    {{ subtitle(3162) }}
                                </p>
                            </div>
                            <div class="dropdown-list__value dropdown-list__value--single"
                                 *ngIf="contact.state === 'lowBattery'"
                                 [ngClass]="{ 'color-alarm': contact.state !== 'noAlarm' }">
                                <p class="dropdown-list__value-name">
                                    {{ subtitle(2884) + ' - ' + subtitle(2885) }}
                                </p>
                            </div>
                            <div class="dropdown-list__value dropdown-list__value--single"
                                 *ngIf="contact.state === 'damaged'"
                                 [ngClass]="{ 'color-alarm': contact.state !== 'noAlarm' }">
                                <p class="dropdown-list__value-name">
                                    {{ subtitle(2883) }}
                                </p>
                            </div>
                        </div>

                    </div>

                    <div class="dropdown-list dropdown-list--grey"
                         *ngIf="zone.showDropdownUnderfloor"
                         (click)="zones.showHideDropdownList(0)"
                         [ngStyle]="{ 'bottom' : zone.zoneStyle.bottom,
                            'top' : zone.zoneStyle.top }">
                        <div class="dropdown-list__item color-basic font-12 font-bold">
                            <p class="dropdown-list__item-name">
                                {{ subtitle(806) }}
                            </p>
                            <div class="dropdown-list__value dropdown-list__value--single">
                                <p class="dropdown-list__value-name">
                                    {{ zone.underfloor.mode | underfloorMode }}
                                </p>
                            </div>
                        </div>

                        <div class="dropdown-list__item color-basic font-12 font-bold">
                            <p class="dropdown-list__item-name">
                                {{ subtitle(4273) }}
                            </p>
                            <div class="dropdown-list__value dropdown-list__value--single">
                                <p class="dropdown-list__value-name">
                                    {{ zone.underfloor.currentState | underfloorState }}
                                </p>
                            </div>
                        </div>

                        <div class="dropdown-list__item color-basic font-12 font-bold">
                            <p class="dropdown-list__item-name">
                                {{ subtitle(4272) }}
                            </p>
                            <div class="dropdown-list__value dropdown-list__value--single">
                                <p *ngIf="zone.underfloor.temperature !== null"
                                   class="dropdown-list__value-name">
                                    {{ zone.underfloor.temperature | format:7 }}
                                </p>
                                <p *ngIf="zone.underfloor.temperature === null"
                                   class="dropdown-list__value-name">
                                    {{ zone.underfloor.currentState | underfloorState }}
                                </p>
                            </div>
                        </div>

                        <div class="dropdown-list__item color-basic font-12 font-bold"
                             *ngIf="zone.underfloor.signalStrength !== null
                                || zone.underfloor.batteryLevel !== null">
                            <p class="dropdown-list__item-name"
                               [ngClass]="{ 'color-alarm': zone.underfloor.batteryLevel <=10
                                    && zone.underfloor.batteryLevel !== null }">
                                {{ subtitle(3589) }}
                            </p>
                            <div class="dropdown-list__value">
                                <div class="dropdown-list__value-wrapper">
                                    <div class="dropdown-list__value dropdown-list__value--small"
                                         *ngIf="zone.underfloor.batteryLevel !== null">
                                        <img class="dropdown-list__battery"
                                             ngSrc="/assets/img/zone_icons/battery.svg"
                                             width="16" height="16" alt=""/>
                                        <p class="dropdown-list__value-name"
                                           data-testid="battery-level"
                                           [ngClass]="{ 'color-alarm': zone.underfloor.batteryLevel <=10
                                                && zone.underfloor.batteryLevel }">
                                            {{ zone.underfloor.batteryLevel | format:8 }}
                                        </p>
                                    </div>
                                </div>
                                <div class="dropdown-list__value-wrapper">
                                    <div class="dropdown-list__value dropdown-list__value--small"
                                         *ngIf="zone.underfloor.signalStrength !== null">
                                        <img class="dropdown-list__signal"
                                             ngSrc="{{ zones.signalIcon(zone.underfloor) }}"
                                             width="16" height="16" alt=""/>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="dropdown-list__item color-basic font-12 font-bold"
                             *ngIf="zone.underfloor.sensorType !== 'null'">
                            <p class="dropdown-list__item-name">
                                {{ subtitle(3396) }}
                            </p>
                            <div class="dropdown-list__value dropdown-list__value--single">
                                <p class="dropdown-list__value-name">
                                    {{ zone.underfloor.sensorType | underfloorSensorType }}
                                </p>
                            </div>
                        </div>

                        <div class="dropdown-list__item color-basic font-12 font-bold"
                            *ngIf="zone.underfloor.floorPump !== 'noPump'">
                            <p class="dropdown-list__item-name">
                                {{ subtitle(582) }}
                            </p>
                            <div class="dropdown-list__value dropdown-list__value--single">
                                <p class="dropdown-list__value-name">
                                    {{ zone.underfloor.floorPump == 'off' ? subtitle(922) : subtitle(3498) }}
                                </p>
                            </div>
                        </div>

                        <div class="dropdown-list__item color-basic font-12 font-bold"
                             *ngIf="zone.underfloor.events.correctWork">
                            <p class="dropdown-list__item-name">
                                {{ subtitle(3956) }}
                            </p>
                            <div class="dropdown-list__value dropdown-list__value--single">
                                <p class="dropdown-list__value-name">
                                    {{ subtitle(594) }}
                                </p>
                            </div>
                        </div>
                        <div class="dropdown-list__item color-basic font-12 font-bold"
                             *ngIf="zone.underfloor.events.serviceError">
                            <p class="dropdown-list__item-name">
                                {{ subtitle(3956) }}
                            </p>
                            <div class="dropdown-list__value dropdown-list__value--single">
                                <p class="dropdown-list__value-name">
                                    {{ subtitle(4277) }}
                                </p>
                            </div>
                        </div>
                        <div class="dropdown-list__item color-basic font-12 font-bold"
                             *ngIf="zone.underfloor.events.noCommunication">
                            <p class="dropdown-list__item-name color-alarm">
                                {{ subtitle(4282) }}
                            </p>
                            <div class="dropdown-list__value dropdown-list__value--single">
                                <p class="dropdown-list__value-name color-alarm">
                                    {{ subtitle(1808) }}
                                </p>
                            </div>
                        </div>
                        <div class="dropdown-list__item color-basic font-12 font-bold"
                             *ngIf="zone.underfloor.events.sensorDamaged">
                            <p class="dropdown-list__item-name color-alarm">
                                {{ subtitle(4282) }}
                            </p>
                            <div class="dropdown-list__value dropdown-list__value--single">
                                <p class="dropdown-list__value-name color-alarm">
                                    {{ subtitle(1807) }}
                                </p>
                            </div>
                        </div>
                        <div class="dropdown-list__item color-basic font-12 font-bold"
                             *ngIf="zone.underfloor.events.lowBattery">
                            <p class="dropdown-list__item-name color-alarm">
                                {{ subtitle(4282) }}
                            </p>
                            <div class="dropdown-list__value dropdown-list__value--single">
                                <p class="dropdown-list__value-name color-alarm">
                                    {{ subtitle(2727) }}
                                </p>
                            </div>
                        </div>
                        <div class="dropdown-list__item color-basic font-12 font-bold"
                             *ngIf="zone.underfloor.events.lowSignal">
                            <p class="dropdown-list__item-name color-alarm">
                                {{ subtitle(4282) }}
                            </p>
                            <div class="dropdown-list__value dropdown-list__value--single">
                                <p class="dropdown-list__value-name color-alarm">
                                    {{ subtitle(698) }}
                                </p>
                            </div>
                        </div>
                        <div class="dropdown-list__item color-basic font-12 font-bold"
                             *ngIf="zone.underfloor.events.tempTooHigh">
                            <p class="dropdown-list__item-name color-alarm">
                                {{ subtitle(4282) }}
                            </p>
                            <div class="dropdown-list__value dropdown-list__value--single">
                                <p class="dropdown-list__value-name color-alarm">
                                    {{ subtitle(4280) }}
                                </p>
                            </div>
                        </div>
                        <div class="dropdown-list__item color-basic font-12 font-bold"
                             *ngIf="zone.underfloor.events.tempTooLow">
                            <p class="dropdown-list__item-name color-alarm">
                                {{ subtitle(4282) }}
                            </p>
                            <div class="dropdown-list__value dropdown-list__value--single">
                                <p class="dropdown-list__value-name color-alarm">
                                    {{ subtitle(4278) }}
                                </p>
                            </div>
                        </div>
                    </div>

                    <div class="zone__during-change bg-dark-shadow"
                         *ngIf="zone.zone.duringChange
                            && !(zone.zone.zoneState == 'sensorDamaged'
                            || zone.zone.zoneState == 'noCommunication')">
                        <div class="zone__alert-top"></div>
                        <p class="zone__during-change-name font-14">
                            {{ subtitle(3162) }}
                        </p>
                        <div class="zone__during-change-img">
                            <loader></loader>
                        </div>
                    </div>

                    <div class="zone__alert-mobile cursor-pointer"
                         (click)="zones._selectZone(zone); zones.goToZoneInfo()"
                         *ngIf="!(zone.zone.zoneState == 'sensorDamaged' || zone.zone.zoneState == 'noCommunication')
                            && (zone.actuatorAlert || zone.windowSensorAlert || zone.additionalContactAlert || zone.underfloorAlert)">
                        <svg width="50" height="50"
                             class="zone__alert-icon zone__alert-icon--mobile tile__svg--alarm-animation">
                            <text x="25" y="45" font-size="65"
                                  font-weight="bold" text-anchor="middle">!
                            </text>
                        </svg>
                    </div>

                    <div class="zone__relay-status-mobile fill-style"
                         (click)="zones._selectZone(zone); zones.goToState('zone')"
                         *ngIf="!(zone.zone.zoneState == 'sensorDamaged' || zone.zone.zoneState == 'noCommunication')">
                        <img class="zone__relay-status-img cursor-pointer"
                             ngSrc="/assets/img/zone_icons/sun_v1-1.svg"
                             data-testid="relay-status-mobile-icon"
                             [ngClass]="{ 'zone__relay-status-mobile--animated': zone.zone.flags.relayState == 'on' }"
                             width="45" height="45" alt=""
                             *ngIf="!zone.zone.flags.minOneWindowOpen && zone.zone.flags.algorithm == 'heating'"/>
                        <img class="zone__relay-status-img cursor-pointer"
                             ngSrc="/assets/img/zone_icons/snowflake.svg"
                             data-testid="relay-status-mobile-icon"
                             [ngClass]="{ 'zone__relay-status-mobile--animated': zone.zone.flags.relayState == 'on' }"
                             width="45" height="45" alt=""
                             *ngIf="!zone.zone.flags.minOneWindowOpen && zone.zone.flags.algorithm == 'cooling'"/>
                        <icon [iconName]="'window_sun'"
                              [className]="'zone__window-img cursor-pointer fill-black fill-black--stroke fill-icon-grey fill-icon-grey--stroke'"
                              data-testid="open-window-mobile"
                              *ngIf="zone.zone.flags.minOneWindowOpen">
                        </icon>
                    </div>

                    <div class="zone__alert bg-dark-shadow" data-testid="tile-alert"
                         *ngIf="zone.zone.zoneState == 'sensorDamaged'
                            || zone.zone.zoneState == 'noCommunication'"
                         [ngClass]="{ 'zone__alert--without-actuator': zone.actuators.length === 0 }">
                        <div class="zone__alert-top"></div>
                        <div class="zone__alert-wrapper">
                            <p class="zone__alert-name font-18"
                               *ngIf="zone.zone.zoneState == 'sensorDamaged'">
                                {{ subtitle(1807) }}
                            </p>
                            <p class="zone__alert-name font-18"
                               *ngIf="zone.zone.zoneState == 'noCommunication'">
                                {{ subtitle(1808) }}
                            </p>
                            <svg width="50" height="50"
                                 class="tile__svg--alarm-animation fill-alert">
                                <text x="25" y="45" font-size="65"
                                      font-weight="bold" text-anchor="middle">!
                                </text>
                            </svg>
                        </div>
                    </div>

                    <div class="zone__window-opened"
                         *ngIf="zone.zone.flags.minOneWindowOpen
                            && zone.zone.zoneState != 'sensorDamaged'
                            && zone.zone.zoneState != 'noCommunication'">
                        <icon [iconName]="'window_sun'"
                              data-testid="open-window-desktop"
                              [className]="'zone__window-img fill-icon-grey fill-icon-grey--stroke'">
                        </icon>
                    </div>

                    <div class="zone__controller-mode cursor-pointer"
                         *ngIf="zones.zonesParameter.value > 0"
                         (click)="showAlertControllerMode()">
                    </div>

                    <div class="zone__alert zone__alert--tile bg-dark-shadow"
                         *ngIf="parameters.isZonesSystemControllerType()
                            && container !== null
                            && container.data.parameters.signal === -3">
                        <div class="zone__alert-top"></div>
                        <div class="zone__alert-wrapper">
                            <p class="zone__alert-name font-18"
                               *ngIf="parameters.isZonesSystemControllerType()
                                && container.data.parameters.signal === -3">
                                {{ subtitle(1808) }}
                            </p>
                            <svg width="50" height="50"
                                 class="tile__svg--alarm-animation fill-alert">
                                <text x="25" y="45" font-size="65"
                                      font-weight="bold" text-anchor="middle">!
                                </text>
                            </svg>
                        </div>
                    </div>
                </div>
            </ng-container>

            <ng-container *ngIf="parameters.isZonesSystemControllerType()
                && container !== null
                && container.data.tiles.length">
                <div class="zone bg-zone color-light color-grey-text box-shadow border-light"
                     *ngFor="let tile of container.data.tiles">
                     <zones-tile [tile]="tile"></zones-tile>
                </div>
            </ng-container>

            <ng-container *ngFor="let tile of database.getZoneTiles()">
                <div class="zone bg-zone color-light color-grey-text box-shadow border-light"
                     *ngIf="(database.zones.getValue()['globalSchedules']
                     && database.zones.getValue()['globalSchedules'].elements.length == 5)
                       && (tile.visibility != false)
                       && (tile.type !== 61)
                       && (tile.type != 50)
                       && !(tile.type == 1
                       && tile.params.workingStatus == false)
                       && !parameters.isZonesSystemControllerType()">
                     <zones-tile [tile]="tile"></zones-tile>
                </div>
            </ng-container>
        </zones-container>
    </div>

    <zones-container
            *ngIf="parameters.isZonesSystemControllerType() && zonesSystem.systemTiles.length > 0"
            [containerName]="subtitle(2972)">
        <div class="zone bg-zone color-light color-grey-text box-shadow border-light"
             *ngFor="let tile of zonesSystem.systemTiles">
             <zones-tile [tile]="tile"></zones-tile>
        </div>
    </zones-container>
</div>

<inactive-module></inactive-module>

<div class="module-inactive bg-light-shadow"
     *ngIf="parameters.selectedModule.moduleStatus === null
        && parameters.selectedModule.controllerStatus === null">
    <p class="module-inactive__info bg-style color-light font-16 cursor-pointer"
       (click)="registerModule()">
        {{ subtitle(1319) }}
    </p>
</div>
